import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Zongrenshu = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 64 64"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <filter
              height="29.335"
              width="22.667"
              y="0"
              x="0"
              colorInterpolationFilters="sRGB"
              filterUnits="objectBoundingBox"
              id="cda33__b"
            >
              <feFlood
                result="BackgroundImageFix"
                floodOpacity="0"
              />
              <feBlend
                result="shape"
                in2="BackgroundImageFix"
                in="SourceGraphic"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
                in="SourceAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite
                k3="1"
                k2="-1"
                operator="arithmetic"
                in2="hardAlpha"
              />
              <feColorMatrix values="0 0 0 0 0.8230999708175659 0 0 0 0 0.9404033422470093 0 0 0 0 1 0 0 0 1 0" />
              <feBlend
                result="effect1_innerShadow"
                in2="shape"
              />
            </filter>
            <filter
              height="10.67"
              width="21.337"
              y="-3"
              x="-4"
              colorInterpolationFilters="sRGB"
              filterUnits="objectBoundingBox"
              id="cda33__d"
            >
              <feFlood
                result="BackgroundImageFix"
                floodOpacity="0"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                in="SourceAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feColorMatrix values="0 0 0 0 0.03921568766236305 0 0 0 0 0.42352941632270813 0 0 0 0 1 0 0 0 0.5600000023841858 0" />
              <feBlend
                result="effect1_dropShadow"
                in2="BackgroundImageFix"
              />
              <feBlend
                result="shape"
                in2="effect1_dropShadow"
                in="SourceGraphic"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
                in="SourceAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation=".75" />
              <feComposite
                k3="1"
                k2="-1"
                operator="arithmetic"
                in2="hardAlpha"
              />
              <feColorMatrix values="0 0 0 0 0.12156862765550613 0 0 0 0 0.7058823704719543 0 0 0 0 1 0 0 0 1 0" />
              <feBlend
                result="effect2_innerShadow"
                in2="shape"
              />
            </filter>
            <filter
              height="10.67"
              width="18.67"
              y="-3"
              x="-4"
              colorInterpolationFilters="sRGB"
              filterUnits="objectBoundingBox"
              id="cda33__e"
            >
              <feFlood
                result="BackgroundImageFix"
                floodOpacity="0"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                in="SourceAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feColorMatrix values="0 0 0 0 0.03921568766236305 0 0 0 0 0.42352941632270813 0 0 0 0 1 0 0 0 0.5600000023841858 0" />
              <feBlend
                result="effect1_dropShadow"
                in2="BackgroundImageFix"
              />
              <feBlend
                result="shape"
                in2="effect1_dropShadow"
                in="SourceGraphic"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
                in="SourceAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation=".75" />
              <feComposite
                k3="1"
                k2="-1"
                operator="arithmetic"
                in2="hardAlpha"
              />
              <feColorMatrix values="0 0 0 0 0.12156862765550613 0 0 0 0 0.7058823704719543 0 0 0 0 1 0 0 0 1 0" />
              <feBlend
                result="effect2_innerShadow"
                in2="shape"
              />
            </filter>
            <filter
              height="10.67"
              width="16.003"
              y="-3"
              x="-4"
              colorInterpolationFilters="sRGB"
              filterUnits="objectBoundingBox"
              id="cda33__f"
            >
              <feFlood
                result="BackgroundImageFix"
                floodOpacity="0"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                in="SourceAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feColorMatrix values="0 0 0 0 0.03921568766236305 0 0 0 0 0.42352941632270813 0 0 0 0 1 0 0 0 0.5600000023841858 0" />
              <feBlend
                result="effect1_dropShadow"
                in2="BackgroundImageFix"
              />
              <feBlend
                result="shape"
                in2="effect1_dropShadow"
                in="SourceGraphic"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
                in="SourceAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation=".75" />
              <feComposite
                k3="1"
                k2="-1"
                operator="arithmetic"
                in2="hardAlpha"
              />
              <feColorMatrix values="0 0 0 0 0.12156862765550613 0 0 0 0 0.7058823704719543 0 0 0 0 1 0 0 0 1 0" />
              <feBlend
                result="effect2_innerShadow"
                in2="shape"
              />
            </filter>
            <linearGradient
              id="cda33__c"
              y2=".913"
              x2=".894"
              y1=".047"
              x1=".068"
            >
              <stop
                stopColor="#1FB4FF"
                offset="0%"
              />
              <stop
                stopColor="#07A1EE"
                offset="100%"
              />
            </linearGradient>
            <clipPath id="cda33__a">
              <rect
                rx="32"
                height="64"
                width="64"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#cda33__a)">
            <rect
              fill="#F0F5F5"
              rx="32"
              height="64"
              width="64"
            />
            <circle
              fill="#F0F5F5"
              cy="32"
              cx="32"
              r="32"
              style={{ mixBlendMode: 'passthrough' }}
            />
            <g filter="url(#cda33__b)">
              <path
                fill="url(#cda33__c)"
                fillRule="evenodd"
                d="M29.667 18.402a1.336 1.336 0 1 0-2.667 0v1.266h-2.667q-1.38 0-2.357.977Q21 21.62 21 23.002v20q0 1.38.976 2.357.977.976 2.357.976h16q1.381 0 2.357-.976.977-.977.977-2.358v-20q0-1.38-.977-2.356-.976-.977-2.357-.977h-2.666v-1.266l.002-.067a1.335 1.335 0 1 0-2.669.067v1.266h-5.333v-1.266Z"
              />
            </g>
            <g filter="url(#cda33__d)">
              <path
                fill="#FFF"
                fillRule="evenodd"
                d="M27.067 29.668a1.336 1.336 0 1 1 0-2.666H37.6a1.333 1.333 0 0 1 1.402 1.333 1.335 1.335 0 0 1-1.402 1.333H27.067Z"
              />
            </g>
            <g filter="url(#cda33__e)">
              <path
                fill="#FFF"
                fillRule="evenodd"
                d="M27.067 35.002a1.336 1.336 0 1 1 0-2.667h7.866a1.335 1.335 0 1 1 0 2.667h-7.866Z"
              />
            </g>
            <g filter="url(#cda33__f)">
              <path
                fill="#FFF"
                fillRule="evenodd"
                d="M27.067 40.335a1.336 1.336 0 1 1 0-2.667h5.2a1.335 1.335 0 1 1 0 2.667h-5.2Z"
              />
            </g>
          </g>
        </g>
      </svg>
    )
  }
)
